import {
  Actions,
  Subjects,
  useIsRbacEnabled,
  useIsTeamMultiSeat,
  useUserAbilitiesContext,
} from 'context/user/UserContext';
import { StudioProjectVersion } from '../../server/graphql/__generated.types';

export const useCanSelectProject = () => {
  const isTeamUser = useIsTeamMultiSeat();

  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canSelectLegacy = isTeamUser;
  const canSelectRbac =
    ability.can(Actions.Read, Subjects.TeamWorkspace) &&
    ability.can(Actions.Create, Subjects.TeamWorkspace);
  return isRbacEnabled ? canSelectRbac : canSelectLegacy;
};

export const useCanMoveProject = () => {
  const isTeamUser = useIsTeamMultiSeat();

  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canMoveProjectLegacy = isTeamUser;
  const canMoveProjectRbac =
    ability.can(Actions.Read, Subjects.TeamWorkspace) &&
    ability.can(Actions.Create, Subjects.TeamWorkspace);
  return isRbacEnabled ? canMoveProjectRbac : canMoveProjectLegacy;
};

export const useCanShowProjectLocation = () => {
  const isTeamUser = useIsTeamMultiSeat();

  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canShowProjectLocationLegacy = isTeamUser;
  const canShowProjectLocationRbac = ability.can(
    Actions.Read,
    Subjects.TeamWorkspace
  );
  return isRbacEnabled
    ? canShowProjectLocationRbac
    : canShowProjectLocationLegacy;
};

export const useCanSubscribeProjectRealtime = () => {
  const isTeamUser = useIsTeamMultiSeat();

  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canSubscribeProjectRealtimeLegacy = isTeamUser;
  const canSubscribeProjectRealtimeRbac = ability.can(
    Actions.Read,
    Subjects.TeamWorkspace
  );
  return isRbacEnabled
    ? canSubscribeProjectRealtimeRbac
    : canSubscribeProjectRealtimeLegacy;
};

export const useCanShowAdditionalLanguagesUpsell = (
  studioProjectVersions: StudioProjectVersion[] | undefined
) => {
  const isTeamUser = useIsTeamMultiSeat();
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();
  // if users can see legacy then they should get upsell
  // otherwise they should only see universal projects
  // this "hack" is to avoid having to surface the feature launch date on
  // the frontend
  const withLegacy = studioProjectVersions?.some(v =>
    v.includes(StudioProjectVersion.Legacy)
  );
  if (!withLegacy) {
    return false;
  }
  const canShowUpsellLegacy = isTeamUser;
  const canShowUpsellRbac = ability.can(Actions.Read, Subjects.TeamWorkspace);
  return isRbacEnabled ? canShowUpsellRbac : canShowUpsellLegacy;
};

export const useCanCreateProject = () => {
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();
  return isRbacEnabled ? ability.can(Actions.Create, Subjects.Projects) : true;
};

export default {
  useCanSelectProject,
  useCanSubscribeProjectRealtime,
  useCanShowAdditionalLanguagesUpsell,
  useCanCreateProject,
};
